import React, {useEffect, useRef, useState} from 'react'
import debounce from 'lodash/debounce'
import Media from 'react-media'
import Player from '../player'
import ResultNotification from '../resultNotification'
import bem from '../../helpers/bem'
import Card from '../card'
import {
  isActivePlayer,
} from '../../helpers/board'
import ButtonsWrapper from '../buttonsWrapper'
import {useOuterClick} from '../../hooks/common'
import Carousel from '../../containers/carousel'
import {resize} from '../../constants/events'
import {
  FLOP_TYPE,
  RIVER_TYPE,
  TABLE,
  TURN_TYPE,
} from '../../constants/board'
import './style.scss'
import {
  BOARD_DEALER,
  BOARD_GET_RESULTS_BUTTON,
  BOARD_GET_RESULTS_BUTTON_POC,
  BOARD_RESET_BUTTON,
  BOARD_RESET_BUTTON_POC,
} from '../../constants/translations'
import {
  BUTTON_TYPE_BLUE,
  BUTTON_TYPE_GREY,
} from '../../constants/buttonTypes'
import {MAX_WIDTH_834} from '../../constants/mediaQueries';

const Board = ({
                 players,
                 table,
                 winner,
                 removeCard,
                 hints,
                 closeHint,
                 activeField,
                 setActiveField,
                 setChosenCard,
                 calculateOdds,
                 getWinnerHand,
                 activeRules,
                 reset,
                 setCardsMenu,
                 setWinner,
                 isPOC,
                 noCommunityCards,
                 hiLo,
                 isWinnerCard,
                 isNotWinnerPlayer,
                 getVisibleSlides,
                 getCurrentSlide,
                 isSplitPotWinner,
                 isOddsWinner,
                 isCardChosen,
                 setBoardCarousel,
                 carousel,
                 isMobile,
                 setCursorPointer,
               }) => {
  const block = 'board';
  const notificationPocBlock = useRef(null);
  const [width, setWidth] = useState(window.innerWidth);
  const visibleSlides = getVisibleSlides(width);
  const isSlidesOverflow = players.length > visibleSlides;
  const newCurrentSlide = getCurrentSlide(visibleSlides);

  useEffect(() => {
    const handleResize = debounce(() => setWidth(window.innerWidth), 100);
    window.addEventListener(resize, handleResize);

    return () => {
      window.removeEventListener(resize, handleResize)
    }
  });

  const [resultsVisibility, setResultsVisibility] = useState(false);
  useOuterClick(
    () => setResultsVisibility(false),
    notificationPocBlock
  );

  const [currentSlide, setCurrentSlide] = useState(newCurrentSlide);
  useEffect(() => {
      setCurrentSlide(newCurrentSlide)
    },
    [currentSlide, activeField, newCurrentSlide]
  );

  const handleClickTableCard = () => {
    setActiveField(TABLE, 1, true);
    if (setCardsMenu) {
      setCardsMenu(true)
    }
  };

  const handleClickSubmit = () => {
    return isPOC
      ? calculateOdds(isSlidesOverflow && setResultsVisibility)
      : getWinnerHand(setCurrentSlide)
  };

  const handleClickOutsideNotification = () => {
    setWinner(false);
    setBoardCarousel({hasChanged: false})
  };

  const getIsPocMods = () => {
    return {
      'is-poc': isPOC,
    }
  };

  const getPlayersMods = (playerId) => {
    return {
      [playerId]: true,
    }
  };

  const getCommunityCardsMods = () => {
    return {
      'community-cards': !noCommunityCards,
    }
  };

  setCursorPointer(isMobile && (!!winner || resultsVisibility));

  return (
    <div className={bem({block})}>
      <div className={bem({block, elem: 'wrapper'})}>
        <div
          className={bem({block, elem: 'poker-table', mods: {...getIsPocMods(), ...getCommunityCardsMods()}})}
        >
          {isPOC && (
            <div className={bem({block, elem: 'poker-table-dealer'})}>
              {BOARD_DEALER}
            </div>
          )}
          {table && (
            <div className={bem({
              block,
              elem: 'poker-table-cards',
              mods: {...getIsPocMods(), ...getCommunityCardsMods()}
            })}>
              {table.flop && (
                <div className={bem({
                  block,
                  elem: 'poker-table-flop',
                  mods: {...getIsPocMods(), ...getCommunityCardsMods()}
                })}>
                  {table.flop.map((card, index) => {
                    return <Card
                      key={card + index}
                      handId={index}
                      rank={card.rank}
                      suit={card.suit}
                      removeCard={removeCard}
                      setChosenCard={setChosenCard}
                      chosen={isCardChosen(FLOP_TYPE, card, index)}
                      updateActiveField={handleClickTableCard}
                      type={FLOP_TYPE}
                      board
                    />
                  })}
                </div>
              )}
              {table.turn !== undefined && (
                <div className={bem({
                  block,
                  elem: 'poker-table-turn',
                  mods: {...getIsPocMods(), ...getCommunityCardsMods()}
                })}>
                  <Card
                    rank={table.turn.rank}
                    suit={table.turn.suit}
                    removeCard={removeCard}
                    setChosenCard={setChosenCard}
                    chosen={isCardChosen(TURN_TYPE, table.turn)}
                    type={TURN_TYPE}
                    updateActiveField={handleClickTableCard}
                    board
                  />
                </div>
              )}
              {table.river !== undefined && (
                <div className={bem({block, elem: 'poker-table-river'})}>
                  <Card
                    rank={table.river.rank}
                    suit={table.river.suit}
                    removeCard={removeCard}
                    setChosenCard={setChosenCard}
                    type={RIVER_TYPE}
                    updateActiveField={handleClickTableCard}
                    chosen={isCardChosen(RIVER_TYPE, table.river)}
                    board
                  />
                </div>
              )}
              {isPOC && !noCommunityCards && (
                <div className={bem({
                  block,
                  elem: 'poker-table-river',
                  mods: {...getIsPocMods(), ...getCommunityCardsMods()}
                })}>
                  <Card
                    type={RIVER_TYPE}
                    board
                    disable
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <Media query={MAX_WIDTH_834}>
          {matches =>
            matches ? (
              <Carousel
                players={players}
                visibleSlides={visibleSlides}
                isPOC={isPOC}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                activeField={activeField}
                isNotWinnerPlayer={isNotWinnerPlayer}
                winner={winner}
                setActiveField={setActiveField}
                setChosenCard={setChosenCard}
                isWinnerCard={isWinnerCard}
                noCommunityCards={noCommunityCards}
                hiLo={hiLo}
                setCardsMenu={setCardsMenu}
                removeCard={removeCard}
                isSplitPotWinner={isSplitPotWinner}
                isOddsWinner={isOddsWinner}
                isSlidesOverflow={isSlidesOverflow}
                carousel={carousel}
                setBoardCarousel={setBoardCarousel}
              />
            ) : (
              <div className={bem({block, elem: 'players', mods: getIsPocMods()})}>
                {players.map((player, index) => {
                  const playerId = player.id;
                  return <div
                    className={bem({block, elem: 'player', mods: getPlayersMods(playerId)})}
                    key={playerId}
                  >
                    <Player
                      player={player}
                      removeCard={removeCard}
                      activeField={isActivePlayer(players, player, activeField, winner)}
                      noCommunityCards={noCommunityCards}
                      hiLo={hiLo}
                      splitPotWinner={isSplitPotWinner(playerId)}
                      oddsWinner={isOddsWinner(player.win)}
                      setActiveField={setActiveField}
                      setChosenCard={setChosenCard}
                      isNotWinnerPlayer={isNotWinnerPlayer(player)}
                      isWinnerCard={isWinnerCard}
                      index={index}
                      isPOC={isPOC}
                    />
                  </div>
                })}
              </div>
            )}
        </Media>
        {isMobile && (
          <React.Fragment>
            <div className={bem({block, elem: 'buttons-wrapper'})}>
              <ButtonsWrapper
                click={handleClickSubmit}
                type={BUTTON_TYPE_BLUE}
              >
                {isPOC
                  ? BOARD_GET_RESULTS_BUTTON_POC
                  : BOARD_GET_RESULTS_BUTTON
                }
              </ButtonsWrapper>
              <ButtonsWrapper
                click={reset}
                type={BUTTON_TYPE_GREY}
              >
                {isPOC
                  ? BOARD_RESET_BUTTON_POC
                  : BOARD_RESET_BUTTON
                }
              </ButtonsWrapper>
            </div>
            {resultsVisibility && (
              <div className={bem({
                block,
                elem: 'poc-notification',
                mods: getIsPocMods()
              })}>
                <div
                  className={bem({block, elem: 'result-players'})}
                  ref={notificationPocBlock}
                >
                  {players.map((player, index) => {
                    return <div
                      className={bem({block, elem: 'player'})}
                      key={player.id}
                    >
                      <Player
                        player={player}
                        index={index}
                        isPOC={isPOC}
                        isResult
                      />
                    </div>
                  })}
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        {winner && (
          <div className={bem({block, elem: 'notification'})}>
            <ResultNotification
              winner={winner}
              clickOutside={isMobile && handleClickOutsideNotification}
            />
          </div>
        )}
      </div>
    </div>
  )};

export default Board;